/* eslint-disable indent */
import styled from 'styled-components';
import { Button as AntdButton } from 'antd';
import { COLORS, FONTS, STYLES } from 'utils/constants/styles';

const Button = styled(AntdButton)`
    white-space: initial;
    height: auto;
    color: ${props => props.theme.text.black} !important;
    background-color: transparent;
    border-color: ${props => props.theme.background.revertTheme};
    border-radius: ${props => (props.type === 'link' ? '' : STYLES.BUTTON_BORDER_RADIUS)};
    text-transform: ${props => (props.type === 'link' ? '' : 'uppercase')};
    padding: ${STYLES.BUTTON_PADDING};
    font-weight: ${FONTS.SEMI_BOLD};

    &:hover {
        > span {
            color: ${props => props.theme.text.black} !important;
        }
        color: ${props => props.theme.text.black} !important;
    }
`;

export default Button;
